export default __webpack_public_path__ + "static/media/usemango_logo.13d8fa05.png";